import '../css/global.css'

// Import and register Swiper custom elements once.
import { register } from 'swiper/element/bundle'
register()

// Dynamic imports for components that are conditionally loaded
const dynamicImports = [
  { path: () => import('./header.js'), element: 'mega-menu' },
  { path: () => import('./carousel.js'), element: 'basis-carousel' },
  { path: () => import('./animated-menu.js'), element: 'basis-animated-menu' },
  { path: () => import('@lottiefiles/lottie-player'), element: 'lottie-player' },
  { path: () => import('./accordion.js'), element: 'basis-accordion' },
  { path: () => import('./office-availability.js'), element: 'office-availability' },
  { path: () => import('./archive-filter.js'), element: 'archive-filter' },
  { path: () => import('./truncate-text.js'), element: 'truncate-text' },
  { path: () => import('./flip-card.js'), element: 'flip-card' },
  { path: () => import('./fixed-image.js'), element: 'fixed-image' },
  { path: () => import('./header-search.js'), element: 'header-search' },
  { path: () => import('./search-filter.js'), element: 'search-filter' },
  { path: () => import('./infinite-scroll.js'), element: 'infinite-scroll' },
  { path: () => import('./services-accordion.js'), element: '.services-accordion-block' },
  { path: () => import('./practice-header.js'), element: 'practice-header' },
  { path: () => import('./newsletter-form.js'), element: 'newsletter-form' },
  { path: () => import('./contact-form.js'), element: 'contact-form' },
  { path: () => import('./hubspot-forms.js'), element: 'hubspot-form' },
  { path: () => import('./office-carousel.js'), element: 'office-carousel' },
  { path: () => import('./gated-form.js'), element: 'gated-form' },
  { path: () => import('./you-are-in.js'), element: 'you-are-in' },
  { path: () => import('./marquee.js'), element: 'marquee-container' },
]

const loadImports = async imports => {
  try {
    for (const { path, element } of imports) {
      const elements = document.querySelectorAll(element)
      if (elements.length > 0) {
        console.log('Loading module for: ' + element)
        const module = await path()
        elements.forEach(el => {
          if (module.default) {
            // Check if the default export is a class constructor
            if (
              typeof module.default === 'function' &&
              /^\s*class\s+/.test(module.default.toString())
            ) {
              new module.default(el)
            } else {
              module.default(el)
            }
          }
        })
      }
    }
  } catch (error) {
    console.error('Error loading imports:', error)
  }
}

// Load dynamic imports when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => loadImports(dynamicImports))
} else {
  loadImports(dynamicImports)
}
